<template>
  <div id="campaign-list" class="campaigns-container">
    <div v-if="!offlinePlatform">
      <table-campaigns :type="type" :campaigns="campaigns" :allowCancel="true" @openPopUp="popUpCancel = true" @cancelPopUp="popUpCancel = false" :popUpCancel="popUpCancel" :cancelCampaign="cancel" :fixed="false" :isEmail="false" :isSms="false" />
    </div>
    <div v-else>
      <offline></offline>
    </div>
  </div>
</template>

<script>
  import moduleCampaign from '@/store/campaign/moduleCampaign'
  import TableCampaigns from './TableCampaigns'
  import { campaignWhatsappType, campaignSmsType, campaignEmailType } from '@/supports/campaignSupport'
  import campaignService   from '../../http/requests/campaign'
  import vue from '@/main'
  import Offline from "@/views/offline-platform/Offline.vue";

  export default {
    name: 'campaigns',
    components: { Offline, TableCampaigns },
    data() {
      return {
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
        addNewDataSidebar: false,
        sidebarData: {},
        type: 0,
        popUpCancel: false
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.popUpCancel) {
        this.popUpCancel = false;
        setTimeout( ()=> {
          next();
        }, 1);
      } 
      else {
        next();
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }

        return 0
      },
      campaigns() {
        return this.$store.state.campaign.campaigns
      },
      queriedItems() {
        return 0
      },
      offlinePlatform() {
        return this.$store.state.offlinePlatform;
      }
    },
    methods: {
      addNewData() {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      viewData(data) {
        this.sidebarData = this.$_.cloneDeep(data)
        this.toggleDataSidebar(true)
      },
      toggleDataSidebar(val=false) {
        this.addNewDataSidebar = val
      },
      loadData() {
        if (this.$route.name === 'whatsapp-campaigns') {
          this.type = campaignWhatsappType
          this.$store.dispatch(
            'campaign/fetch',
            { type: campaignWhatsappType, page: 1, itemsPerPage: 4 }
          )
        }
      },
      cancel(campaign) {
        campaignService.cancel(campaign.id, this.type).then(() => {
          vue.$vs.notify({
            title: 'Cancelamento Realizado',
            text: 'As mensagens não disparadas foram removidas',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          
          this.loadData()
        })
      }
    },
    watch: {
      '$route.name'() {
        this.loadData()
      }
    },
    created() {
      if (!moduleCampaign.isRegistered) {
        this.$store.registerModule('campaign', moduleCampaign)
        moduleCampaign.isRegistered = true
      }

      if (this.$route.name === 'whatsapp-campaigns') {
        this.type = campaignWhatsappType
        this.$store.dispatch(
          'campaign/fetch',
          { type: campaignWhatsappType, page: 1, itemsPerPage: 4 }
        )
      }

      if (this.$route.name === 'sms-campaigns') {
        this.type = campaignSmsType
        this.$store.dispatch(
          'campaign/fetch',
          { type: campaignSmsType, page: 1, itemsPerPage: 4 }
        )
      }

      if (this.$route.name === 'email-campaigns') {
        this.type = campaignEmailType
        this.$store.dispatch(
          'campaign/fetch',
          { type: campaignEmailType, page: 1, itemsPerPage: 4 }
        )
      }

      this.$store.dispatch("updateWhatsappStatus");
      this.$store.dispatch("updateMaintenanceStatus");
      this.loadData()
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #campaign-list {
    .con-vs-tabs {
      .con-ul-tabs {
        margin-left: 1.5rem;
        margin-right: 1.5rem;
      }
    }

    .vs-con-table {

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
